<template>
  <b-container class="content" style="max-width:680px;">
    <div class="content">
      <b-spinner class="m-4" v-if="isUpdating" />
      <component v-else
        :is="currentComponent"
        v-bind="currentProperties"
        v-on:continue_setup="continueSetup"
        v-on:register="registerSensor"
        v-on:registration_success="registrationSuccessful"
        v-on:select_wifi="selectWifi"
        v-on:manual_wifi_configuration="manualWifiConfig"
        v-on:connection_success="connectionSuccessful"
        v-on:ensure_sensor_is_reachable="isSensorReachable"
        v-on:restart="restart">
      </component>
    </div>
    <div v-if="!isUpdating" class="fluid-container footer mt-2">
      <p class="text-center">{{ $t('mac') }} {{ currentProperties.mac }}</p>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios';
import Registration from './Registration';
import RegistrationSuccess from './RegistrationSuccess';
import SetupStart from './SetupStart';
import SetupSelectWifi from './SetupSelectWifi';
import SetupWifiCredentials from './SetupWifiCredentials';
import SetupWifiManualSSID from './SetupWifiManualSSID';
import SetupWifiSuccess from './SetupWifiSuccess';

export default {
  name: 'Setup',
  components: {
    Registration,
    RegistrationSuccess,
    SetupStart,
    SetupSelectWifi,
    SetupWifiCredentials,
    SetupWifiSuccess,
  },
  data() {
    return {
      interval: '',
      currentComponent: SetupStart,
      currentProperties: {
        mac: '',
        sn: '',
        wifi: ''
      },
      isMacUpdating: true,
      isSNUpdating: true
    }
  },
  computed: {
    isUpdating() {
      return this.isMacUpdating || this.isSNUpdating;
    }
  },
  created () {
    this.getMac();
    this.getSN();
    if (!this.interval) {
      this.interval = setInterval(this.isSensorReachable, 8000);
    }
  },
  beforeDestroyed () {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    restart() {
      this.currentComponent = SetupStart;
    },
    isSensorReachable() {
      axios
        .get('http://10.3.141.1:6762', { timeout: 7000 })
        .catch(error => {
          if (!error.response) {
            // user is not in the same network as the sensor anymore
            clearInterval(this.interval);
            this.$router.replace({ name: 'HomePage' });
          }
        });
    },
    getMac() {
      axios
        .get('http://10.3.141.1:6762/api/v1/mac')
        .then(response => {
          if (response.status == 200) {
            this.currentProperties.mac = response.data.mac;
          }
        })
        .finally(() => {
          this.isMacUpdating = false;
        });
    },
    getSN() {
      axios
        .get('http://10.3.141.1:6762/api/v1/serial')
        .then(response => {
          if (response.status == 200) {
            this.currentProperties.sn = response.data.sn;
          }
        })
        .finally(() => {
          this.isSNUpdating = false;
        });
    },
    registerSensor() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.currentComponent = Registration;
    },
    registrationSuccessful(sn) {
      this.currentProperties.sn = sn;
      this.currentComponent = RegistrationSuccess;
    },
    continueSetup() {
      this.currentComponent = SetupSelectWifi;
    },
    selectWifi(wifi) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.currentProperties.wifi = wifi;
      this.currentComponent = SetupWifiCredentials;
    },
    manualWifiConfig() {
      this.currentComponent = SetupWifiManualSSID;
    },
    connectionSuccessful(wifi) {
      this.currentProperties.wifi = wifi;
      this.currentComponent = SetupWifiSuccess;
    }
  }
}
</script>

<style scoped>
.fluid-container.footer > *:last-child {
  margin-bottom: 0px;
}
</style>
